import { View, type ViewStyle } from "react-native";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";

// ── Grouped Card ──

export function GroupedCard({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: ViewStyle;
}) {
  return (
    <View style={[GLASS_CARD_STYLE, { marginBottom: 20 }, style]}>
      {children}
    </View>
  );
}

// ── Status Dot ──

export function StatusDot({ color }: { color: string }) {
  return (
    <View
      style={{
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: color,
      }}
    />
  );
}
